module.exports = __webpack_public_path__ + "img/tozy.6e19716e.jpg";